import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { EncryptionService } from '../encyption.service';
import { isPlatformBrowser, Location } from '@angular/common';
import { KreuzfahrtFilters } from '@app/models/filtermodels/KreuzfahrtFilters';
import { AuthGuardService } from '../auth-guard.service';
@Injectable({
    providedIn: 'root',
})
export class CruiseFiltersService {
    protected filters: BehaviorSubject<KreuzfahrtFilters>;
    myKrzfilters: KreuzfahrtFilters = {} as KreuzfahrtFilters;
    protected extrasCount: BehaviorSubject<number>;
    constructor(
        protected router: Router,
        protected encservice: EncryptionService,
        protected route: ActivatedRoute,
        protected location: Location,
        protected guardService: AuthGuardService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.filters = new BehaviorSubject(null);
        this.extrasCount = new BehaviorSubject(0);
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => {
                this.initFilters();
            }, 50);
        }
    }

    get getfilters$() {
        return this.filters.asObservable();
    }

    initFilters() {
        if (this.route.snapshot.queryParams['params'] && this.route.snapshot.queryParams['params'].length > 0) {
            const tokenFromUI = this.route.snapshot.queryParams['params']?.slice(-16);
            const data = this.route.snapshot.queryParams['params']?.slice(0, (this.route.snapshot.queryParams['params'].length - 16));
            this.myKrzfilters = JSON.parse(this.encservice.deencrypt(tokenFromUI, data));
            this.filters.next(this.myKrzfilters);
        } else {
            if (!this.myKrzfilters?.productType) {
                this.setDefault();
            }
        }
    }

    setDefault() {
        this.myKrzfilters = {} as KreuzfahrtFilters;
        const today = new Date();
        this.myKrzfilters.productType = 'kreuzfahrt';
        this.myKrzfilters.cruisesuchetype = '';
        this.myKrzfilters.cruiseduration = '6-9';
        this.myKrzfilters.cruisemaxanzpass = '';
        this.myKrzfilters.cruiseboardlanguage = '';
        this.myKrzfilters.cruisemaxprice = '';
        this.myKrzfilters.cruisecabincat = '';
        this.myKrzfilters.cruisestarthafen = null;
        this.myKrzfilters.cruisezielhafen = null;
        this.myKrzfilters.airports = null;
        this.myKrzfilters.cruisemaxanzpass = '';
        this.myKrzfilters.reisendeResult = {
            adults: 2,
            children: []
        };

        this.myKrzfilters.reisezeitraumResult = {
            start: new Date(today.setDate(today.getDate() + 14)).toISOString(),
            end: new Date(today.setDate(today.getDate() + 30)).toISOString()
        };
        this.filters.next(this.myKrzfilters);
    }

    resetAllExtrasHome() {
        this.setDefault();
    }

    resetAllExtras() {
        this.myKrzfilters.cruisesuchetype = '';
        this.myKrzfilters.cruiseduration = '6-9';
        this.myKrzfilters.cruiseboardlanguage = '';
        this.myKrzfilters.cruisemaxprice = '';
        this.myKrzfilters.cruisemaxanzpass = '';
        this.myKrzfilters.cruisecabincat = '';
        this.myKrzfilters.schiffes = [];
        this.myKrzfilters.promo = '';
        this.myKrzfilters.pmc = '';
        this.changeUrl();
    }

    setExtraCount(value) {
        this.extrasCount.next(value);
    }

    get extrasCount$(): Observable<number> {
        return this.extrasCount.asObservable();
    }

    setFilters(myKrzfilters) {
        this.myKrzfilters = myKrzfilters;
        this.filters.next(this.myKrzfilters);
    }

    cruisesuchetype(ev, nohome) {
        this.myKrzfilters.cruisesuchetype = ev;
        if (nohome) {
            this.changeUrl();
        }
    }

    reisezeitraumResult(start, end, mindur, maxdur) {
        this.myKrzfilters.reisezeitraumResult = {
            start: start,
            end: end
        };
        if (mindur !== -1) {
            this.myKrzfilters.cruiseduration = mindur === maxdur ? mindur : mindur + '-' + maxdur;
        }
    }

    reisedauerResult(ev, nohome) {
        this.myKrzfilters.reisedauerResult = ev;
        if (nohome) {
            this.changeUrl();
        }
    }

    cruisecompanys(ev) {
        this.myKrzfilters.cruisecompanys = ev;
    }

    cruiseregion(ev) {
        this.myKrzfilters.cruiseregion = ev;
    }

    schiffes(ev) {
        this.myKrzfilters.schiffes = ev;
    }

    cruiseduration(ev, nohome) {
        this.myKrzfilters.cruiseduration = ev;
        if (nohome) {
            this.changeUrl();
        }
    }

    cruiseboardlanguage(ev, nohome) {
        this.myKrzfilters.cruiseboardlanguage = ev;
        if (nohome) {
            this.changeUrl();
        }
    }

    cruisemaxanzpass(ev, nohome) {
        this.myKrzfilters.cruisemaxanzpass = ev;
        if (nohome) {
            this.changeUrl();
        }
    }

    cruiseid(ev) {
        this.myKrzfilters.cruiseid = ev;
        this.changeUrl();
    }

    cruisecabincat(ev, nohome) {
        this.myKrzfilters.cruisecabincat = ev;
        if (nohome) {
            this.changeUrl();
        }
    }

    cruisemaxprice(ev, nohome) {
        this.myKrzfilters.cruisemaxprice = ev;
        if (nohome) {
            this.changeUrl();
        }
    }

    productType(value) {
        this.myKrzfilters.productType = value;
        this.changeUrl();
    }

    cruisestarthafen(ev) {
        this.myKrzfilters.cruisestarthafen = ev;
    }

    cruisezielhafen(ev) {
        this.myKrzfilters.cruisezielhafen = ev;
    }

    promo(ev) {
        this.myKrzfilters.promo = ev;
    }

    pmc(ev) {
        this.myKrzfilters.pmc = ev;
    }

    airports(ev) {
        this.myKrzfilters.airports = ev;
    }

    reisendeResult(ev) {
        this.myKrzfilters.reisendeResult = ev;
    }

    changeUrl() {
        const url = this.router.createUrlTree([], { queryParams: { params: this.encservice.encrypt(this.myKrzfilters), replaceUrl: true } }).toString();
        this.location.replaceState(url);
        this.filters.next(this.myKrzfilters);
    }

    onlySetRealParams(params) {
        // console.log(params)
        this.myKrzfilters = JSON.parse(JSON.stringify(params));
        this.filters.next(this.myKrzfilters);
    }

    setReference(reference) {
        this.myKrzfilters.reference = reference;
    }

    gotourl() {
        if (this.guardService.getPartnerId()?.length > 0) {
            const url = this.router.createUrlTree([this.guardService.getPartnerId(), 'cruise'], { queryParams: { params: this.encservice.encrypt(this.myKrzfilters), replaceUrl: true } }).toString();
            // console.log(this.myKrzfilters);
            const link = document.createElement('a');
            link.href = url;
            // link.target = '_blank';
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    gotooffer(param) {
        this.myKrzfilters = JSON.parse(JSON.stringify(param));
        if (this.guardService.getPartnerId()?.length > 0) {
            const url = this.router.createUrlTree([this.guardService.getPartnerId(), 'cruise', 'offers'], { queryParams: { params: this.encservice.encrypt(this.myKrzfilters), replaceUrl: true } }).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    cruisezwischenhaefen(ports: any[], saveToUrl = true) {


        this.myKrzfilters.cruisezwischenhaefen = ports;

        const firstPort = ports && ports.length > 0 ? ports[0] : null;
        this.myKrzfilters.zwi = firstPort?.id || '';

        if (saveToUrl) this.changeUrl();
        this.filters.next(this.myKrzfilters);
    }

    gotoofferNewTab(param) {
        const navigationExtras: NavigationExtras = {
            queryParams: { params: this.encservice.encrypt(param) }
        };
        const path = this.router.createUrlTree([this.guardService.getPartnerId(), 'cruise', 'offers'], navigationExtras).toString();
        const link = document.createElement('a');
        link.href = path;
        link.target = '_blank';
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    onlychangeurl() {
        const url = this.router
            .createUrlTree([], {
                queryParams: {
                    params: this.encservice.encrypt(this.myKrzfilters),
                    replaceUrl: true,
                },
            })
            .toString();
        this.location.replaceState(url);
    }
}
